import React, { useEffect } from "react";
import "./EAModal.scss";
import { IoMdClose } from "react-icons/io";
import EAIconButton from "../Buttons/EAIconButton";
import EAButton from "../Buttons/EAButton";
import { useTranslation } from "react-i18next";
import useParentMessage from "../../../../utils/hooks/useParentMessage";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  onAccept?: () => void;
  hideButtons?: boolean;
  cancelButtonLabel?: string;
  acceptButtonLabel?: string;
  hideAcceptButton?: boolean;
}

const EAModal: React.FC<IProps> = ({
  isOpen,
  onClose,
  title,
  children,
  onAccept,
  hideButtons = false,
  cancelButtonLabel = "",
  acceptButtonLabel = "",
  hideAcceptButton = false,
}) => {
  const { t } = useTranslation();
  const { scrollToCenter } = useParentMessage();

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (target.classList.contains("eamodal-overlay")) {
        onClose(); // Zamykamy modal, jeśli kliknięto poza nim
      }
    };

    if (isOpen) {
      document.body.style.overflow = "hidden"; // Blokuje przewijanie strony
      document.addEventListener("click", handleOutsideClick);
      scrollToCenter();
    } else {
      document.body.style.overflow = "unset"; // Przywraca przewijanie
    }

    return () => {
      document.body.style.overflow = "unset";
      document.removeEventListener("click", handleOutsideClick);
    };
    //eslint-disable-next-line
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="eamodal-overlay">
      <div className="eamodal-container">
        <div className="eamodal-header">
          <h5>{title}</h5>
          <EAIconButton title="Zamknij" icon={<IoMdClose />} onClick={onClose} variant="icon" />
        </div>
        <div className="eamodal-body">{children}</div>
        {!hideButtons && (
          <div className="eamodal-footer">
            <EAButton
              variant="outlined"
              title={cancelButtonLabel ? cancelButtonLabel : t("anuluj")}
              onClick={onClose}
            />
            {!hideAcceptButton && (
              <EAButton title={acceptButtonLabel ? acceptButtonLabel : t("akceptuj")} onClick={onAccept} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default EAModal;
